// IL SEGNALE ANONIMO della prima mano di QBridge (ADR-0236 §7, scelta di Luca L-3402 (a), I-872): quando una persona finisce la mano
// guidata, il dispositivo manda UNA chiamata al game host, che la conta (un dispositivo, un giorno). Serve al bersaglio «1.000 persone
// che finiscono la prima mano»; niente altro.
//
// ⛔ Questo e' l'UNICO file della TMA che esce dalla zona K9a verso quel game host, e lo fa cosi':
//  · una `fetch` sola, una POST a `<VITE_QBRIDGE_TELEMETRY_URL>/v1/telemetry/first-hand`, `credentials: 'omit'`, niente `Authorization`,
//    niente intestazioni nostre (solo `Content-Type`, che il game host pretende: `text/plain` e' un 400, quindi niente `sendBeacon`);
//  · il corpo e' il letterale `{ lingua }` con la lingua dell'INTERFACCIA (i18n), mai quella di Telegram: nessun `initData`, nessun id,
//    nessuna ora (l'ora la mette il server), nessun token, nemmeno se la persona e' entrata col suo account;
//  · parte SOLO alla transizione falso → vero di `qlash.bridge.primaManoFatta`, guardata da FUORI da K9a (`useProgressi`): nessun file di
//    K9a importa questo modulo. Niente nuovi tentativi, niente coda, niente chiavi nuove in `localStorage`; un errore e' silenzioso, e un
//    conteggio perso e' un conteggio perso (ADR-0236, punto 6);
//  · l'interruttore e' `VITE_QBRIDGE_TELEMETRY_URL`: vuota ⇒ ZERO chiamate. Sta solo in `.env.staging`.
// `tools/verify-bridge.ts` tiene fermo tutto questo.
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { env } from '@/env';
import { useProgressi } from '@/lib/bridge/progressi';

const PERCORSO = '/v1/telemetry/first-hand';

/** La lingua base dell'interfaccia (`pt-BR` → `pt`), o `undefined` se non e' un tag riconoscibile: il corpo allora e' `{}`. */
export function linguaDelSegnale(tag: string | null | undefined): string | undefined {
  const base = (tag ?? '').trim().toLowerCase().split(/[-_]/)[0] ?? '';
  return /^[a-z]{2,3}$/.test(base) ? base : undefined;
}

/** Una chiamata, senza attesa e senza esito: l'interruttore e' letto QUI, a ogni chiamata. */
export function mandaSegnalePrimaMano(lingua: string | undefined): void {
  const url = env.bridgeTelemetryUrl;
  if (!url) return;
  try {
    void fetch(`${url.replace(/\/+$/, '')}${PERCORSO}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lingua }),
      credentials: 'omit',
    }).catch(() => undefined);
  } catch {
    /* un segnale che non parte non e' un errore da mostrare */
  }
}

/** Da montare UNA volta, fuori da K9a (`AppShell`): al passaggio della prima mano da «non fatta» a «fatta» manda il segnale. */
export function usePrimaManoSegnale(): void {
  const { progressi } = useProgressi();
  const { i18n } = useTranslation();
  const fatta = progressi.primaManoFatta;
  const prima = useRef(fatta);
  useEffect(() => {
    const eraFatta = prima.current;
    prima.current = fatta;
    if (!eraFatta && fatta)
      mandaSegnalePrimaMano(linguaDelSegnale(i18n.resolvedLanguage ?? i18n.language));
  }, [fatta, i18n]);
}
